export enum WREX_COLUMNS {
    /**
     * @value Add content here
     * @description Placeholder indicating the user what to do
     */
    ADD_CONTENT_HERE = 'WREX_COLUMNS.ADD_CONTENT_HERE',
    /**
     * @value {"one":"Column","other":"%NB% Columns"}
     * @description Columns element to add in a rich text
     */
    OCCURRENCES_COLUMNS = 'WREX_COLUMNS.OCCURRENCES_COLUMNS',
    /**
     * @value Columns toolbar
     * @description Label for columns toolbar
     */
    TOOLBAR = 'WREX_COLUMNS.TOOLBAR',
}
